import { render, staticRenderFns } from "./DiscogsMatching.vue?vue&type=template&id=4cde253b&scoped=true&"
import script from "./DiscogsMatching.vue?vue&type=script&lang=js&"
export * from "./DiscogsMatching.vue?vue&type=script&lang=js&"
import style0 from "./DiscogsMatching.vue?vue&type=style&index=0&id=4cde253b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde253b",
  null
  
)

export default component.exports